import { date } from '@ipfabric/utils';
import { getValue, mapSeverityColumn } from 'containers/DownloadReport/helpers';
import { isValid } from 'date-fns';
import humanizeDuration from 'humanize-duration';

const ucfirst = (s) => s.substr(0, 1).toUpperCase() + s.substring(1);

const formatXdpProtocol = (data) => {
  if (Array.isArray(data)) {
    return data.join(' ');
  }
  return data;
};

const formatTimestamp = (data, multiple = 1) => {
  try {
    return humanizeDuration(getValue(data) * multiple);
  } catch {
    return 'N/A';
  }
};

const formatDate = (data, timezone, format) => {
  try {
    const localDate = date.utcToUserTimeZone(getValue(data), timezone);
    if (!isValid(localDate)) {
      return 'N/A';
    }
    return date.formatUtcTimestampInTimeZone(getValue(data), timezone, format);
  } catch {
    return 'N/A';
  }
};

const mapTableRow = (tableKey, row, timezone, dateFormat) => {
  return Object.keys(row).reduce((acc, colKey) => {
    const value = row[colKey];
    // Special rules for mapping special tables & cols
    if (
      ['cdpUnidirectional', 'cdpAll', 'cdpUnmanaged'].includes(tableKey) &&
      colKey === 'protocols'
    ) {
      acc[colKey] = mapSeverityColumn(formatXdpProtocol(value), value);
      return acc;
    }
    if (
      ['configRegister', 'unexpectedReloads'].includes(tableKey) &&
      colKey === 'uptime'
    ) {
      acc[colKey] = mapSeverityColumn(formatTimestamp(value, 1000), value);
      return acc;
    }
    if (
      ['endOfSupport'].includes(tableKey) &&
      ['endSale', 'endMaintenance', 'endSupport'].includes(colKey)
    ) {
      acc[colKey] = mapSeverityColumn(
        formatDate(value, timezone, dateFormat),
        value,
      );
      return acc;
    }
    acc[colKey] = mapSeverityColumn(value, value);
    return acc;
  }, {});
};

const mapTables = (json, timezone, dateFormat) => {
  return Object.keys(json).reduce((acc, tableKey) => {
    if (Array.isArray(json[tableKey])) {
      acc[`has${ucfirst(tableKey)}`] = json[tableKey].length > 0;
      acc[tableKey] = json[tableKey].map((row) =>
        mapTableRow(tableKey, row, timezone, dateFormat),
      );
      return acc;
    }
    acc[tableKey] = json[tableKey];
    return acc;
  }, {});
};

export { mapTables };
